import { render, staticRenderFns } from "./editStaff.vue?vue&type=template&id=2630abb3&"
import script from "./editStaff.vue?vue&type=script&lang=js&"
export * from "./editStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/editStaff.vue
// module id = 1654
// module chunks = 0